import { useState, useEffect } from "react";
import { supabase } from "../components/SupabaseClient";

export const useResourceGroups = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGroups = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data, error } = await supabase.rpc("get_all_groups");

        if (error) {
          throw error;
        }

        setGroups(data || []);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch resource groups:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();
    const interval = setInterval(fetchGroups, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return { groups, loading, error };
};
